var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 5.20768C10.3465 5.20768 10.6263 5.4875 10.6263 5.83268V10.8327C10.6263 11.1779 10.3465 11.4577 10.0013 11.4577C9.65612 11.4577 9.3763 11.1779 9.3763 10.8327V5.83268C9.3763 5.4875 9.65612 5.20768 10.0013 5.20768Z",
    fill: "#FF4336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4277 13.7005C10.6843 13.9314 10.7051 14.3266 10.4742 14.5832L10.4659 14.5925C10.2349 14.849 9.83977 14.8698 9.5832 14.6389C9.32663 14.408 9.30583 14.0128 9.53674 13.7562L9.54508 13.747C9.77599 13.4904 10.1712 13.4696 10.4277 13.7005Z",
    fill: "#FF4336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.29102C5.74411 2.29102 2.29297 5.74215 2.29297 9.99935C2.29297 14.2565 5.74411 17.7077 10.0013 17.7077C14.2585 17.7077 17.7096 14.2565 17.7096 9.99935C17.7096 5.74215 14.2585 2.29102 10.0013 2.29102ZM1.04297 9.99935C1.04297 5.0518 5.05375 1.04102 10.0013 1.04102C14.9489 1.04102 18.9596 5.0518 18.9596 9.99935C18.9596 14.9469 14.9489 18.9577 10.0013 18.9577C5.05375 18.9577 1.04297 14.9469 1.04297 9.99935Z",
    fill: "#FF4336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.5b43cdaa940ab3430e0537a99cc5ef3b.svg";
export { ForwardRef as ReactComponent };